import { createContext, useContext } from 'react'

import { StepPage } from 'directFlow/types'

const PageContext = createContext<StepPage | null>(null)

export const PageProvider = PageContext.Provider

export const useCurrentPage = () => {
  const page = useContext(PageContext)

  if (page === null) {
    throw new Error('`PageProvider` must be used as a parent to be able to use `useCurrentPage`')
  }

  return page
}
